import { Link } from 'react-router-dom';

interface ArticleCard {
  title: string;
  excerpt: string;
  path: string;
  imageSeq: string;
  imageUrl: string;
}

const articles: ArticleCard[] = [
  {
    title: 'Best PandabuySpreadsheet Budget Finds Under $20',
    excerpt: 'Discover incredible fashion steals without breaking the bank. Our curated budget spreadsheet has hidden gems across every category.',
    path: '/pandabuy-sheet-budget-finds',
    imageSeq: 'art-preview-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20affordable%20fashion%20accessories%20and%20clothing%20with%20price%20tags%20on%20bright%20white%20background%2C%20clean%20product%20photography%20with%20soft%20even%20lighting%2C%20budget%20friendly%20shopping%20concept%2C%20colorful%20items%20neatly%20arranged%2C%20fresh%20modern%20ecommerce%20aesthetic&width=600&height=400&seq=art-preview-01&orientation=landscape',
  },
  {
    title: 'The PandabuySpreadsheet Sneaker Discovery Guide',
    excerpt: 'From retro classics to limited editions, learn how to navigate the sneaker section of PandabuySpreadsheet like a pro.',
    path: '/pandabuy-sheet-sneaker-guide',
    imageSeq: 'art-preview-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Multiple%20pairs%20of%20stylish%20sneakers%20in%20rainbow%20color%20arrangement%20on%20clean%20white%20shelving%2C%20bright%20studio%20lighting%2C%20sneakerhead%20collection%20display%2C%20colorful%20footwear%20editorial%20photography%2C%20organized%20minimalist%20retail%20aesthetic&width=600&height=400&seq=art-preview-02&orientation=landscape',
  },
  {
    title: 'Streetwear Essentials in PandabuySpreadsheet',
    excerpt: 'Build your ultimate streetwear wardrobe with our curated hoodies, tees, and outerwear picks from the spreadsheet.',
    path: '/pandabuy-sheet-streetwear-essentials',
    imageSeq: 'art-preview-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=Urban%20streetwear%20outfit%20flat%20lay%20with%20oversized%20hoodie%20cargo%20pants%20and%20cap%20on%20grey%20concrete%20texture%2C%20natural%20daylight%20with%20subtle%20shadows%2C%20contemporary%20fashion%20editorial%20photography%2C%20neutral%20tones%20with%20pops%20of%20red%2C%20cool%20minimalist%20vibe&width=600&height=400&seq=art-preview-03&orientation=landscape',
  },
];

const articles2: ArticleCard[] = [
  {
    title: 'Trending TikTok PandabuySpreadsheet Finds 2026',
    excerpt: 'The viral products everyone is talking about on TikTok — now organized and easy to find in one spreadsheet.',
    path: '/pandabuy-sheet-trending-tiktok',
    imageSeq: 'art-preview-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=Viral%20social%20media%20trending%20fashion%20products%20displayed%20on%20phone%20screen%20with%20physical%20items%20beside%2C%20bright%20ring%20light%20illumination%2C%20content%20creator%20aesthetic%2C%20modern%20influencer%20product%20photography%2C%20trendy%20colorful%20composition&width=600&height=400&seq=art-preview-04&orientation=landscape',
  },
  {
    title: 'Luxury Style Dupes in PandabuySpreadsheet',
    excerpt: 'Get the high-end look for less. Our luxury dupe spreadsheet helps you find premium style at accessible prices.',
    path: '/pandabuy-sheet-luxury-dupes',
    imageSeq: 'art-preview-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20designer%20inspired%20handbag%20and%20silk%20scarf%20on%20white%20marble%20surface%20with%20gold%20jewelry%2C%20soft%20luxurious%20lighting%20with%20warm%20highlights%2C%20high-end%20fashion%20editorial%20photography%2C%20champagne%20and%20cream%20color%20palette%2C%20sophisticated%20minimalist%20aesthetic&width=600&height=400&seq=art-preview-05&orientation=landscape',
  },
  {
    title: 'Complete PandabuySpreadsheet Accessories Guide',
    excerpt: 'Watches, bags, belts, and jewelry — the accessories spreadsheet has everything to complete your outfit.',
    path: '/pandabuy-sheet-accessories-guide',
    imageSeq: 'art-preview-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Various%20fashion%20accessories%20including%20watches%20sunglasses%20and%20bracelets%20arranged%20in%20organized%20grid%20on%20dark%20velvet%2C%20overhead%20studio%20lighting%2C%20luxury%20accessory%20catalog%20photography%2C%20metallic%20reflections%20and%20leather%20textures%2C%20elegant%20dark%20mood&width=600&height=400&seq=art-preview-06&orientation=landscape',
  },
];

const articles3: ArticleCard[] = [
  {
    title: 'PandabuySpreadsheet Seasonal Picks for 2026',
    excerpt: 'Stay seasonally relevant with our curated picks for spring, summer, fall, and winter — updated throughout the year.',
    path: '/pandabuy-sheet-seasonal-picks',
    imageSeq: 'art-preview-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=Four%20seasonal%20fashion%20mood%20boards%20showing%20spring%20summer%20fall%20winter%20outfits%20on%20white%20background%2C%20bright%20airy%20photography%2C%20editorial%20fashion%20planning%20concept%2C%20soft%20pastels%20to%20rich%20earth%20tones%2C%20organized%20quadrant%20layout&width=600&height=400&seq=art-preview-07&orientation=landscape',
  },
  {
    title: 'PandabuySpreadsheet Quality & Sizing Guide',
    excerpt: 'How to read quality ratings, sizing charts, and material descriptions to make confident purchasing decisions.',
    path: '/pandabuy-sheet-quality-guide',
    imageSeq: 'art-preview-08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20fabric%20texture%20samples%20with%20measuring%20tape%20and%20quality%20inspection%20tools%20on%20light%20wood%20table%2C%20soft%20diffused%20daylight%2C%20textile%20quality%20control%20photography%2C%20various%20material%20swatches%2C%20professional%20minimalist%20aesthetic&width=600&height=400&seq=art-preview-08&orientation=landscape',
  },
  {
    title: 'PandabuySpreadsheet Beginner Tips & Tricks',
    excerpt: 'New to spreadsheet shopping? This guide covers everything from navigation basics to advanced filtering techniques.',
    path: '/pandabuy-sheet-beginner-tips',
    imageSeq: 'art-preview-09',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20spreadsheet%20interface%20with%20coffee%20notebook%20and%20pen%20on%20clean%20desk%2C%20warm%20morning%20sunlight%20from%20window%2C%20productivity%20lifestyle%20photography%2C%20organized%20workspace%20with%20plants%2C%20modern%20home%20office%20aesthetic&width=600&height=400&seq=art-preview-09&orientation=landscape',
  },
];

function ArticleCardComponent({ article }: { article: ArticleCard }) {
  return (
    <Link
      to={article.path}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div style={{ aspectRatio: '3/2' }} className="overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <span className="inline-flex items-center gap-1.5 mt-3 text-xs font-semibold text-primary-600 whitespace-nowrap">
          Read Article
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}

export default function ArticleGridSection() {
  return (
    <section id="articles" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300 text-xs font-semibold text-foreground-600 uppercase tracking-wider mb-4 bg-background-50">
            SEO Articles
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            PandabuySpreadsheet Knowledge Base
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-xl mx-auto">
            In-depth guides and curated content to help you master the art of spreadsheet shopping — from budget finds to luxury dupes.
          </p>
        </div>

        {/* Row 1 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-8">
          {articles.map((a) => (
            <ArticleCardComponent key={a.path} article={a} />
          ))}
        </div>

        {/* Guide CTA Banner */}
        <div className="mb-8 rounded-2xl overflow-hidden relative" style={{ aspectRatio: '21/9', maxHeight: '260px' }}>
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20inviting%20workspace%20with%20laptop%20showing%20spreadsheet%20surrounded%20by%20curated%20fashion%20pieces%2C%20soft%20natural%20window%20lighting%2C%20editorial%20lifestyle%20photography%2C%20neutral%20sage%20and%20cream%20tones%2C%20organized%20creative%20desk%20setup%20with%20coffee%20and%20plant&width=1400&height=600&seq=article-grid-cta&orientation=landscape"
            alt="Ultimate PandabuySpreadsheet Guide"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/20 flex items-center">
            <div className="px-6 md:px-10 py-6">
              <h3 className="font-heading text-xl md:text-3xl font-bold text-white mb-3 leading-snug">
                The Ultimate PandabuySpreadsheet Guide
              </h3>
              <p className="text-white/80 text-sm md:text-base max-w-md mb-5">
                Your comprehensive resource for everything PandabuySpreadsheet — read our flagship guide.
              </p>
              <Link
                to="/pandabuy-sheet-ultimate-guide"
                className="inline-flex items-center gap-2 bg-white text-foreground-950 px-6 py-3 rounded-full text-sm font-semibold hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Shopping Guide
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-8">
          {articles2.map((a) => (
            <ArticleCardComponent key={a.path} article={a} />
          ))}
        </div>

        {/* Row 3 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles3.map((a) => (
            <ArticleCardComponent key={a.path} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}